import { FC } from "react";

interface ImageContentProps {
    setOpenImage: () => void;
    src: string;
}

const ImageContent: FC<ImageContentProps> = ({
    setOpenImage,
    src
}) => {
  return (
    <div className="w-[990px] rounded-2xl flex justify-center items-center">
        <img className="mt-[20px]" width="100%" height="100%" src={src} alt="Изображение письма" />
    </div>
  )
}

export default ImageContent
